<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body"
    :class="{'is-hidden-header' : targetScrollFlg}"
    @scroll="handleScroll"
  >
  <BackgroundImage />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <!-- ViewLicense -->
    <transition name="popup">
      <PCContractAssignLicenseForPackage
        v-if="state.visibleLicenseForPackage"
        @close="action.productClose"
        @submit="action.productSubmit"
        @create="state.visibleCreate = true"
      />
    </transition>

    <!-- Detail Popup -->
    <transition name="popup">
      <PCContractAccountDetail
        v-if="state.visibleDetail"
        @closeDetail="state.visibleDetail = false"
        @openEditPopup="state.visibleDetail = false, state.visibleEdit = true"
      />
    </transition>

    <!-- Create Popup -->
    <transition name="popup">
      <PCContractAccountCreate
        v-if="state.visibleCreate"
        @closeCreate="state.visibleCreate = false"
        @submit="action.createSubmit"
      />
    </transition>

    <!-- Edit Popup -->
    <transition name="popup">
      <PCContractAccountEdit
        v-if="state.visibleEdit"
        @closeEdit="state.visibleEdit = false"
        @openAdminPopup="state.visibleEdit = false, state.visibleAdminTransfer = true"
      />
    </transition>

    <!-- Administrator Transfer Popup -->
    <transition name="popup">
      <PCContractAdministratorTransfer
        v-if="state.visibleAdminTransfer"
        @closeAdmin="state.visibleAdminTransfer = false"
      />
    </transition>

    <div id="wrapper">
      <PCContractHeader />

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button" 
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn" 
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content"
        style="height:calc(100vh - 16px);"
        >
        <div class="license" id="scroll-target"
          @scroll="handleScroll"
          >
          <div class="license-head">
            <h1 class="hdg03">ライセンス管理</h1>
          </div>
          <div class="license-container">
            <div v-if="state.initialize" class="license-content">
              <p class="txt mb60">ご契約中のサービスを選択してライセンスの付与・変更が可能です。<br>サービスのご利用には、アカウントごとにライセンスを付与いただく必要があります。</p>
              <div class="license-hdg">
                <h2 class="license-hdg-title hdg03">ご契約中のサービス</h2>
                <div v-if="data.packages && data.packages.length > 0" class="license-hdg-aside">
                  <router-link to="/pc/contract-assign-license-table" target="_blank" class="box02-hdg-aside-menu">全サービスのライセンスを表示</router-link>
                </div>
              </div>
              <div v-if="data.packages && data.packages.length > 0" class="license-content-inner">
                <template v-for="(pack, index) in data.packages">
                  <h3 class="hdg04" :key="'packagename_' + index">{{pack.package_name}}</h3>
                  <ul class="column gutter license-content-list mb32" :key="'package_' + index">
                    <li v-for="(product, productIndex) in pack.product_lists" :key="'package_' + index + '_product_' + productIndex" class="column-item col-4 space-gutter license-content-list-item" @click="action.showProduct(index, productIndex)" role="button">
                      <div class="license-box">
                        <div class="license-box-hdg"><span :class="[product.using_license.length >= product.license_number && 'max']">{{product.using_license.length}}</span> / <span>{{product.license_number}}</span></div>
                        <div class="license-box-content">
                          <p class="txt">{{product.name}}</p>
                          <p v-if="product.status === PRODUCT_STATUS.TRIAL" class="txt-sup">トライアル {{formatDateKanji(product.period_end)}}まで</p>
                        </div>
                      </div>
                    </li>
                  </ul>
                </template>
              </div>
              <div v-else class="license-content-inner">
                <p class="txt">ご契約中のサービスはありません。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- content:end -->
      <span id="btnTop" @click="scrollAreaTop('#scroll-target')">TOP</span>
    </div>
  </div>
</template>

<script>
import { defineComponent} from '@vue/composition-api'
import { ContractAssignLicense} from '@/logic/contract/ContractAssignLicense'

import PCContractHeader from '@/components/pc/partial/contract/ContractHeader.vue'
import PCMenu from '@/components/pc/popup/PCMenu.vue'
import PCContractAssignLicenseForPackage from '@/components/pc/popup/PCContractAssignLicenseForPackage.vue'
import PCContractAccountDetail from '@/components/pc/popup/PCContractAccountDetail.vue'
import PCContractAccountCreate from '@/components/pc/popup/PCContractAccountCreate.vue'
import PCContractAccountEdit from '@/components/pc/popup/PCContractAccountEdit.vue'
import PCContractAdministratorTransfer from '@/components/pc/popup/PCContractAdministratorTransfer.vue'

export default defineComponent({
  components: {
    PCContractHeader,
    PCMenu,
    PCContractAssignLicenseForPackage,
    PCContractAccountDetail,
    PCContractAccountCreate,
    PCContractAccountEdit,
    PCContractAdministratorTransfer
  },
  setup (props, context) {
    return { ...ContractAssignLicense(props, context) }
  }
})
</script>

<style lang="scss" scoped>
#header {
  @media screen and (max-width: 1250px) {
    .header-search-tab {
      position: relative;
      &-02 {
        position: absolute;
        top: 52px;
        background-color: #fff;
        border-radius: 4px;
        box-shadow: 0px 3px 6px rgba(0,0,0,.16);
        .header-search-tab-item {
          height: 48px;
          padding: 0 10px;
          a {
            color: $color-link;
            padding: 2px 10px;
            font-size: 1.4rem;
          }
        }
      }
    }
  }
}
#content {
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  margin-bottom: 60px;
  overflow-y: auto;
}
.license {
  width: 100%;
  overflow: auto;
  &-container {
    border-top: 1px solid $color-line;
    padding: 40px 0;
  }
  &-head {
    padding: 30px 40px 25px;
    [class^="hdg"] {
      margin-bottom: 0;
    }
  }
  &-hdg {
    position: relative;
    margin-bottom: 14px;
    &-title {
      margin-bottom: 0;
    }
    &-aside {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translate3d(0, -50%, 0);
      a {
        padding-right: 0;
      }
    }
  }
  &-content {
    max-width: 1105px;
    padding: 0 40px;
    margin: 0 auto;
    &-txt {
      margin-bottom: 50px;
    }
    &-inner {
      border-top: 1px solid $color-line;
      padding-top: 30px;
      .hdg04 {
        margin-bottom: 20px;
      }
    }
    &-list {
      list-style: none;
      margin-bottom: 32px;
      &-item {
        border: 1px solid $color-line;
        border-radius: 4px;
      }
    }
  }
  &-box {
    &-hdg {
      text-align: center;
      font-size: 3.2rem;
      font-weight: bold;
      padding: 25px 10px 27px;
      color: $color-hdg;
      .max {
        color: $color-highlight;
      }
    }
    &-content{
      border-top: 1px solid $color-line;
      padding: 23px 40px 10px;
      .txt {
        line-height: 1.625;
        font-weight: 600;
        margin-bottom: 5px;
      }
    }
  }
}
</style>
